import React, { Component } from 'react';
import base from '../rebase';
var _ = require('lodash');

export default class ProductListCollection extends React.Component {

  constructor(props) {
    super(props);
    this.getBrandById = this.getBrandById.bind(this);
  }

  getBrandById(id) {
    // console.log("get brand by id : " + id);

    var element = _.find(this.props.brands, {id:id});
    // console.log( "getBrandById element : ", element);
    // console.log("getBrandById element end.......");

    if(element != undefined){
      return element;
    } else {
      console.log("FAILED TO FIND ");
      console.log("id", id);
      console.log("brands", this.props.brands);
      console.log("END FAIL TO FIND")
      return null;
    }
  }


  render() {
    if(this.props.language == "chi"){
      var useTextSlabClass = "";
    } else {
      var useTextSlabClass = "text-slab";
    }


    var categoryMenu = this.props.categories.map(
      
      category => (
        <li key={category.linkName}>
        
          <a href={"#" + category.linkName} data-toggle="collapse" className={"nav-link text-uppercase "+ useTextSlabClass + " " + (this.props.currentGroup === category.linkName ? "active" : "") + " collapsed"} aria-expanded="false">
            {this.props.language == "chi" && 
              category.name_chi
            }
            {this.props.language == "en" && 
              category.name
            }
            <small className="d-inline-block text-xs text-lowercase"></small>
            <i className="fa fa-angle-right"></i>
          </a>
          <ul className="nav nav-section-menu collapse" id={category.linkName} aria-expanded="false">
            <li key="all">
              <a className="nav-link" key="all" onClick={() => this.props.handleGroupFiltering(category.linkName, "all")}>{this.props.getTranslatedText("All")}</a>
            </li>
            {Array.isArray(category.brands) && (_.size(category.brands) > 0) && category.brands.map( (brandId, index) =>{//maybe we just need a brand db ref and filter it to get brand's detail with 1 query
                var brand = this.getBrandById(brandId);
                if (brand !==undefined && brand !== null) {
                  return ( 
                    <li key={brand.linkName}>
                      <a className="nav-link" key={brand.linkName} onClick={() => this.props.handleGroupFiltering(category.linkName, brand.linkName)}>{brand.name}</a>
                    </li>
                  );
                }
              })
            }      
          </ul>
        </li >
      )
      , this);

    if (this.props.currentGroup === 'all') {
      var allElement = <a href="#all" data-toggle="collapse" className="nav-link text-uppercase text-slab first active collapsed" aria-expanded="false" onClick={() => this.props.handleGroupFiltering("all", "all")}>{this.props.getTranslatedText("All")}
                          <small className="d-inline-block text-xs text-lowercase"> (active)</small>
        <i className="fa fa-angle-right"></i>
      </a>
    } else {
      var allElement = <a href="#all" data-toggle="collapse" className="nav-link text-uppercase text-slab first collapsed" aria-expanded="false" onClick={() => this.props.handleGroupFiltering("all", "all")}>{this.props.getTranslatedText("All")}</a>
    }



    return (
      <div>
        <ul className="nav nav-section-menu mb-4 py-3">
          <li className="nav-header">{this.props.getTranslatedText("ProductCollection")}</li>
          <li>
            {allElement}
          </li>
          {/*<li>
            <a href="#mens" data-toggle="collapse" className="nav-link text-uppercase text-slab collapsed" aria-expanded="false">
              Water Pump
                  <small className="d-inline-block text-xs text-lowercase"></small>
              <i className="fa fa-angle-right"></i>
            </a>
            <ul className="nav nav-section-menu collapse" id="mens" aria-expanded="false">
              <li><a href="#" className="nav-link">Pentax</a></li>
            </ul>
          </li>
          <li>
            <a href="#womens" data-toggle="collapse" className="nav-link text-uppercase text-slab collapsed" aria-expanded="false"> Automatic Change Over <i className="fa fa-angle-right"></i> </a>
            <ul className="nav nav-section-menu collapse" id="womens" aria-expanded="false">
              <li><a href="#" className="nav-link">Itokoki </a></li>
              <li><a href="#" className="nav-link">Katsura </a></li>
            </ul>
          </li>*/}
          {categoryMenu}
        </ul>
        {/*<div className="p-3 overlay overlay-op-5 rounded flex-valign mb-4 bg-img clickable-element" data-bg-img="assets/img/shop/promo-truck.jpg" data-css="{&quot;background-position&quot;:&quot;center bottom&quot;}" data-url="shop-product.htm" style="background-image: url(&quot;assets/img/shop/promo-truck.jpg&quot;) !important; background-position: center bottom;">
              <h4 className="text-white mb-0">
                Free Shipping
              </h4>
              <p className="text-white mb-0">On all orders over $100</p>
              <hr className="hr-lg my-2 w-20 mx-auto hr-primary">
            </div>*/}

        {/*<!-- Follow Widget -->*/}
        {/* <div className="mb-4">
          <hr className="hr-lg mt-0 mb-2 w-10 ml-0 hr-primary" />
          <h4 className="text-uppercase font-weight-bold mt-0">
            Follow us on
              </h4>
          <a href="#" className="btn btn-icon btn-inverse btn-rounded"> <i className="fa fa-twitter"></i> <span className="sr-only">Twitter</span> </a>
          <a href="#" className="btn btn-icon btn-inverse btn-rounded"> <i className="fa fa-facebook"></i> <span className="sr-only">Facebook</span> </a>
          <a href="#" className="btn btn-icon btn-inverse btn-rounded"> <i className="fa fa-linkedin"></i> <span className="sr-only">Linkedin</span> </a>
          <a href="#" className="btn btn-icon btn-inverse btn-rounded"> <i className="fa fa-google-plus"></i> <span className="sr-only">Google plus</span> </a>
        </div> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/ProductListCollection.js